import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Masked line-by-line reveal for headlines. Pass an array of lines.
export const MaskedLines = ({ lines = [], className = "", delay = 0, lineClassName = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.14 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Fade + slide up on scroll into view
export const FadeUp = ({ children, className = "", delay = 0, y = 40, as: Tag = "div", ...rest }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-90px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export { EASE };
